import { forwardRef } from 'react'
import styles from './ProgressBar.module.css'

const ProgressBar = forwardRef<HTMLProgressElement>(
	(props, ref): JSX.Element => {
		return (
			<progress ref={ref} {...props} max={100} className={styles.progressBar} />
		)
	}
)

ProgressBar.displayName = 'ProgressBar'

export default ProgressBar
